import React from "react";

const HelpRegularIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.6004 7.9999C13.6004 11.0927 11.0932 13.5999 8.00039 13.5999C4.9076 13.5999 2.40039 11.0927 2.40039 7.9999C2.40039 4.90711 4.9076 2.3999 8.00039 2.3999C11.0932 2.3999 13.6004 4.90711 13.6004 7.9999Z",
  stroke: "currentColor",
  strokeOpacity: 0.5,
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.26172 6.45522C6.26172 6.45522 6.45482 4.71729 7.99965 4.71729C9.54448 4.71729 9.73758 5.6828 9.73758 6.45522C9.73758 7.03553 9.41054 7.61592 8.75646 7.86866C8.35859 8.02237 7.99965 8.34585 7.99965 8.77246V8.96556",
  stroke: "currentColor",
  strokeOpacity: 0.5,
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.3857 11.0893C8.3857 11.3026 8.21275 11.4755 7.99949 11.4755C7.78622 11.4755 7.61328 11.3026 7.61328 11.0893C7.61328 10.8761 7.78622 10.7031 7.99949 10.7031C8.21275 10.7031 8.3857 10.8761 8.3857 11.0893Z",
  stroke: "currentColor",
  strokeOpacity: 0.5,
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(HelpRegularIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;